const divPhotoUp = {
  load: 'Cargando...'
};

export default divPhotoUp;
